import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1b13afca&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./detail.vue?vue&type=style&index=1&id=1b13afca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b13afca",
  null
  
)

export default component.exports